"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sparqlModels_1 = require("./sparqlModels");
var _ = require("lodash");
var LABEL_URI = 'http://www.w3.org/2000/01/rdf-schema#label';
var RDF_TYPE_URI = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type';
function getClassTree(response) {
    var tree = [];
    var treeNodes = createClassMap(response.results.bindings);
    // createClassMap ensures we get both elements and parents and we can use treeNodes[treeNode.parent] safely
    for (var nodeId in treeNodes) {
        if (!treeNodes.hasOwnProperty(nodeId)) {
            continue;
        }
        var treeNode = treeNodes[nodeId];
        if (treeNode.parent) {
            var parent_1 = treeNodes[treeNode.parent];
            parent_1.children.push(treeNode);
        }
        else {
            tree.push(treeNode);
        }
    }
    calcCounts(tree);
    return tree;
}
exports.getClassTree = getClassTree;
function createClassMap(sNodes) {
    var treeNodes = {};
    for (var _i = 0, sNodes_1 = sNodes; _i < sNodes_1.length; _i++) {
        var sNode = sNodes_1[_i];
        if (!sparqlModels_1.isRdfIri(sNode.class)) {
            continue;
        }
        var sNodeId = sNode.class.value;
        var node = treeNodes[sNodeId];
        if (node) {
            if (sNode.label) {
                var label = node.label;
                if (label.values.length === 1 && !label.values[0].lang) {
                    label.values = [];
                }
                label.values.push(getLocalizedString(sNode.label));
            }
            if (!node.parent && sNode.parent) {
                node.parent = sNode.parent.value;
            }
        }
        else {
            node = getClassModel(sNode);
            treeNodes[sNodeId] = node;
        }
        // ensuring parent will always be there
        if (node.parent && !treeNodes[node.parent]) {
            treeNodes[node.parent] = getClassModel({ class: { value: node.parent, type: 'uri' } });
        }
    }
    return treeNodes;
}
function calcCounts(children) {
    var _loop_1 = function (node) {
        // no more to count
        if (!node.children) {
            return { value: void 0 };
        }
        // ensure all children have their counts completed;
        calcCounts(node.children);
        // we have to preserve no data here. If nor element nor childs have no count information,
        // we just pass undefined upwards.
        var childCount;
        node.children.forEach(function (_a) {
            var count = _a.count;
            if (count === undefined) {
                return;
            }
            childCount = childCount === undefined ? count : childCount + count;
        });
        if (childCount !== undefined) {
            node.count = node.count === undefined ? childCount : node.count + childCount;
        }
    };
    for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
        var node = children_1[_i];
        var state_1 = _loop_1(node);
        if (typeof state_1 === "object")
            return state_1.value;
    }
}
function getClassInfo(response) {
    var classes = {};
    var _loop_2 = function (binding) {
        if (!binding.class) {
            return "continue";
        }
        var id = binding.class.value;
        var model = classes[id];
        if (model) {
            var newLabel_1 = getLocalizedString(binding.label);
            if (newLabel_1 && !model.label.values.some(function (label) { return isLocalizedEqual(label, newLabel_1); })) {
                model.label.values.push(newLabel_1);
            }
            var instanceCount = getInstCount(binding.instcount);
            if (instanceCount !== undefined) {
                model.count = Math.max(model.count, instanceCount);
            }
        }
        else {
            var label = getLocalizedString(binding.label);
            classes[id] = {
                id: id,
                children: [],
                label: { values: label ? [label] : [] },
                count: getInstCount(binding.instcount),
            };
        }
    };
    for (var _i = 0, _a = response.results.bindings; _i < _a.length; _i++) {
        var binding = _a[_i];
        _loop_2(binding);
    }
    var classesList = [];
    for (var id in classes) {
        if (!classes.hasOwnProperty(id)) {
            continue;
        }
        var model = classes[id];
        classesList.push(model);
    }
    return classesList;
}
exports.getClassInfo = getClassInfo;
function getPropertyInfo(response) {
    var models = {};
    for (var _i = 0, _a = response.results.bindings; _i < _a.length; _i++) {
        var sProperty = _a[_i];
        var sPropertyTypeId = sProperty.prop.value;
        if (models[sPropertyTypeId]) {
            if (sProperty.label) {
                var label = models[sPropertyTypeId].label;
                if (label.values.length === 1 && !label.values[0].lang) {
                    label.values = [];
                }
                label.values.push(getLocalizedString(sProperty.label));
            }
        }
        else {
            models[sPropertyTypeId] = getPropertyModel(sProperty);
        }
    }
    return models;
}
exports.getPropertyInfo = getPropertyInfo;
function getLinkTypes(response) {
    var sInst = response.results.bindings;
    var linkTypes = [];
    var linkTypesMap = {};
    for (var _i = 0, sInst_1 = sInst; _i < sInst_1.length; _i++) {
        var sLink = sInst_1[_i];
        var sInstTypeId = sLink.link.value;
        if (linkTypesMap[sInstTypeId]) {
            if (sLink.label) {
                var label = linkTypesMap[sInstTypeId].label;
                if (label.values.length === 1 && !label.values[0].lang) {
                    label.values = [];
                }
                label.values.push(getLocalizedString(sLink.label));
            }
        }
        else {
            linkTypesMap[sInstTypeId] = getLinkTypeInfo(sLink);
            linkTypes.push(linkTypesMap[sInstTypeId]);
        }
    }
    return linkTypes;
}
exports.getLinkTypes = getLinkTypes;
function triplesToElementBinding(tripples) {
    var map = {};
    var convertedResponse = {
        head: {
            vars: ['inst', 'class', 'label', 'blankType', 'propType', 'propValue'],
        },
        results: {
            bindings: [],
        },
    };
    for (var _i = 0, tripples_1 = tripples; _i < tripples_1.length; _i++) {
        var tripple = tripples_1[_i];
        var trippleId = tripple.subject.value;
        if (!map[trippleId]) {
            map[trippleId] = createAndPushBinding(tripple);
        }
        if (tripple.predicate.value === LABEL_URI && sparqlModels_1.isRdfLiteral(tripple.object)) { // Label
            if (map[trippleId].label) {
                map[trippleId] = createAndPushBinding(tripple);
            }
            map[trippleId].label = tripple.object;
        }
        else if (sparqlModels_1.isRdfLiteral(tripple.object) && sparqlModels_1.isRdfIri(tripple.predicate)) { // Property
            if (map[trippleId].propType) {
                map[trippleId] = createAndPushBinding(tripple);
            }
            map[trippleId].propType = tripple.predicate;
            map[trippleId].propValue = tripple.object;
        }
        else if ( // Class
        tripple.predicate.value === RDF_TYPE_URI &&
            sparqlModels_1.isRdfIri(tripple.object) && sparqlModels_1.isRdfIri(tripple.predicate)) {
            if (map[trippleId].class) {
                map[trippleId] = createAndPushBinding(tripple);
            }
            map[trippleId].class = tripple.object;
        }
    }
    function createAndPushBinding(tripple) {
        var binding = {
            inst: tripple.subject,
        };
        convertedResponse.results.bindings.push(binding);
        return binding;
    }
    return convertedResponse;
}
exports.triplesToElementBinding = triplesToElementBinding;
function getElementsInfo(response, ids) {
    var sInstances = response.results.bindings;
    var instancesMap = {};
    for (var _i = 0, sInstances_1 = sInstances; _i < sInstances_1.length; _i++) {
        var sInst = sInstances_1[_i];
        var sInstTypeId = sInst.inst.value;
        if (!instancesMap[sInstTypeId]) {
            instancesMap[sInstTypeId] = emptyElementInfo(sInstTypeId);
        }
        enrichElement(instancesMap[sInstTypeId], sInst);
    }
    return instancesMap;
}
exports.getElementsInfo = getElementsInfo;
function getEnrichedElementsInfo(response, elementsInfo) {
    var respElements = response.results.bindings;
    for (var _i = 0, respElements_1 = respElements; _i < respElements_1.length; _i++) {
        var respEl = respElements_1[_i];
        var elementInfo = elementsInfo[respEl.inst.value];
        if (elementInfo) {
            elementInfo.image = respEl.image.value;
        }
    }
    return elementsInfo;
}
exports.getEnrichedElementsInfo = getEnrichedElementsInfo;
function getLinksInfo(response) {
    var sparqlLinks = response.results.bindings;
    var linksMap = {};
    for (var _i = 0, sparqlLinks_1 = sparqlLinks; _i < sparqlLinks_1.length; _i++) {
        var sLink = sparqlLinks_1[_i];
        var linkKey = sLink.source.value + " " + sLink.type.value + " " + sLink.target.value;
        if (linksMap[linkKey]) {
            // this can only happen due to error in sparql or when merging properties
            if (sLink.propType) {
                mergeProperties(linksMap[linkKey].properties, sLink.propType, sLink.propValue);
            }
        }
        else {
            linksMap[linkKey] = getLinkInfo(sLink);
        }
    }
    return _.values(linksMap);
}
exports.getLinksInfo = getLinksInfo;
function getLinksTypesOf(response) {
    var sparqlLinkTypes = response.results.bindings.filter(function (b) { return !sparqlModels_1.isRdfBlank(b.link); });
    return sparqlLinkTypes.map(function (sLink) { return getLinkCount(sLink); });
}
exports.getLinksTypesOf = getLinksTypesOf;
function getLinksTypeIds(response) {
    var sparqlLinkTypes = response.results.bindings.filter(function (b) { return !sparqlModels_1.isRdfBlank(b.link); });
    return sparqlLinkTypes.map(function (sLink) { return sLink.link.value; });
}
exports.getLinksTypeIds = getLinksTypeIds;
function getLinkStatistics(response) {
    var sparqlLinkCount = response.results.bindings.filter(function (b) { return !sparqlModels_1.isRdfBlank(b.link); })[0];
    return getLinkCount(sparqlLinkCount);
}
exports.getLinkStatistics = getLinkStatistics;
function getFilteredData(response) {
    var sInstances = response.results.bindings;
    var instancesMap = {};
    for (var _i = 0, sInstances_2 = sInstances; _i < sInstances_2.length; _i++) {
        var sInst = sInstances_2[_i];
        if (!sparqlModels_1.isRdfIri(sInst.inst) && !sparqlModels_1.isRdfBlank(sInst.inst)) {
            continue;
        }
        var iri = sInst.inst.value;
        if (!instancesMap[iri]) {
            instancesMap[iri] = emptyElementInfo(iri);
        }
        enrichElement(instancesMap[iri], sInst);
    }
    return instancesMap;
}
exports.getFilteredData = getFilteredData;
/**
 * Modifies properties with merging with new values, couls be new peroperty or new value for existing properties.
 * @param properties
 * @param propType
 * @param propValue
 */
function mergeProperties(properties, propType, propValue) {
    var property = properties[propType.value];
    if (!property) {
        property = properties[propType.value] = {
            type: 'string',
            values: [],
        };
    }
    var propertyValue = getPropertyValue(propValue);
    if (property.values.every(function (value) { return !isLocalizedEqual(value, propertyValue); })) {
        property.values.push(propertyValue);
    }
}
function enrichElement(element, sInst) {
    if (!element) {
        return;
    }
    if (sInst.label) {
        var label_1 = getLocalizedString(sInst.label);
        var currentLabels = element.label.values;
        if (element.label.values.every(function (value) { return !isLocalizedEqual(value, label_1); })) {
            element.label.values.push(label_1);
        }
    }
    if (sInst.class && element.types.indexOf(sInst.class.value) < 0) {
        element.types.push(sInst.class.value);
    }
    if (sInst.propType && sInst.propType.value !== LABEL_URI) {
        mergeProperties(element.properties, sInst.propType, sInst.propValue);
    }
}
exports.enrichElement = enrichElement;
function isLocalizedEqual(left, right) {
    return left.lang === right.lang && left.text === right.text;
}
function getLocalizedString(label) {
    if (label) {
        return {
            text: label.value,
            lang: label['xml:lang'],
        };
    }
    else {
        return undefined;
    }
}
exports.getLocalizedString = getLocalizedString;
function getInstCount(instcount) {
    return (instcount ? +instcount.value : undefined);
}
exports.getInstCount = getInstCount;
function getClassModel(node) {
    var label = getLocalizedString(node.label);
    return {
        id: node.class.value,
        children: [],
        label: { values: label ? [label] : [] },
        count: getInstCount(node.instcount),
        parent: node.parent ? node.parent.value : undefined,
    };
}
exports.getClassModel = getClassModel;
function getPropertyModel(node) {
    var label = getLocalizedString(node.label);
    return {
        id: node.prop.value,
        label: { values: label ? [label] : [] },
    };
}
exports.getPropertyModel = getPropertyModel;
function getLinkCount(sLinkType) {
    return {
        id: sLinkType.link.value,
        inCount: getInstCount(sLinkType.inCount),
        outCount: getInstCount(sLinkType.outCount),
    };
}
exports.getLinkCount = getLinkCount;
function getPropertyValue(propValue) {
    if (!propValue) {
        return undefined;
    }
    return {
        lang: propValue['xml:lang'],
        text: propValue.value,
    };
}
exports.getPropertyValue = getPropertyValue;
function emptyElementInfo(id) {
    var elementInfo = {
        id: id,
        label: { values: [] },
        types: [],
        properties: {},
    };
    return elementInfo;
}
exports.emptyElementInfo = emptyElementInfo;
function getLinkInfo(sLinkInfo) {
    if (!sLinkInfo) {
        return undefined;
    }
    var linkModel = {
        linkTypeId: sLinkInfo.type.value,
        sourceId: sLinkInfo.source.value,
        targetId: sLinkInfo.target.value,
        properties: {},
    };
    if (sLinkInfo.propType && sLinkInfo.propValue) {
        linkModel.properties[sLinkInfo.propType.value] = {
            type: 'string',
            values: [getPropertyValue(sLinkInfo.propValue)],
        };
    }
    return linkModel;
}
exports.getLinkInfo = getLinkInfo;
function getLinkTypeInfo(sLinkInfo) {
    if (!sLinkInfo) {
        return undefined;
    }
    var label = getLocalizedString(sLinkInfo.label);
    return {
        id: sLinkInfo.link.value,
        label: { values: label ? [label] : [] },
        count: getInstCount(sLinkInfo.instcount),
    };
}
exports.getLinkTypeInfo = getLinkTypeInfo;
